import getOrfsFromSequence from "./getOrfsFromSequence.js";
export default function findOrfsInPlasmid(sequence, circular, minimumOrfSize, useAdditionalOrfStartCodons, isProteinOrOligo) {
  if (isProteinOrOligo) {
    return [];
  }
  const forwardOrfs = getOrfsFromSequence({
    sequence,
    minimumOrfSize,
    forward: true,
    circular,
    useAdditionalOrfStartCodons
  });
  const reverseOrfs = getOrfsFromSequence({
    sequence,
    minimumOrfSize,
    forward: false,
    circular,
    useAdditionalOrfStartCodons
  });
  return forwardOrfs.concat(reverseOrfs);
}
